import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (params) {
  const { data, exec } = useRequest({
    url: '',
    name: 'GET_SHIFT_CAPACITY',
    manual: true,
  });

  useEffect(() => {
    if (
      params.start_time &&
      params.start_time !== '' &&
      params.end_time &&
      params.end_time !== ''
    ) {
      let url = `/api/produce/class/statistics`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) url += '?';
        else url += '&';
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  // useEffect(() => {
  //   if (data && data.length > 0) {
  //     data.forEach(d => {
  //       if (d.class_aid === 'No shift') {
  //         d.class_name = ml('NO_SHIFT');
  //       }
  //     });
  //   }
  // });

  return data || [];
});
